import classnames from 'classnames';
import React from 'react';

import { ShowingTagDto } from '@cineamo/api/models/showing-tag/ShowingTagDto.types';

import { DomainConfigurationDto } from '@/types/DomainConfigurationDto';

import ImageWithTransition from '@cineamo/ui/src/image/ImageWithTransition';

type ShowingTagImageProps = {
    domainConfiguration: DomainConfigurationDto;
    className?: string;
    showingTag: ShowingTagDto;
};

export default function ShowingTagImage(props: ShowingTagImageProps): React.JSX.Element {
    const { domainConfiguration, className, showingTag } = props;
    return (
        <div className={classnames(className, 'w-full flex pointer-events-none select-none')}>
            {showingTag.imageUrl ? (
                <ImageWithTransition
                    className="w-full h-full object-cover"
                    src={showingTag.imageUrl}
                    width={800}
                    height={600}
                    alt={showingTag.imageDescription || showingTag.name}
                />
            ) : (
                <span
                    className="m-auto text-headline-24 lg:text-headline-32 italic truncate p-20 whitespace-pre-wrap text-center"
                    style={
                        domainConfiguration
                            ? {
                                  color: domainConfiguration.style.onPrimaryColor
                              }
                            : undefined
                    }>
                    {showingTag.name}
                </span>
            )}
        </div>
    );
}
